import { collection, doc, onSnapshot, setDoc, updateDoc, Unsubscribe } from 'firebase/firestore';
import { db } from './firebase';

export interface VolunteerNotification {
  id: string;
  createdAt: string;
  reservationId: string;
  reservationCode: string;
  type: 'date_change' | 'note_added' | 'cancelled' | 'new_order';
  title: string;
  message: string;
  read?: boolean;
}

const COLLECTION_NAME = 'volunteerNotifications';

export function subscribeVolunteerNotifications(
  onData: (notifications: VolunteerNotification[]) => void
): Unsubscribe {
  return onSnapshot(
    collection(db, COLLECTION_NAME),
    (snap) => {
      const list: VolunteerNotification[] = snap.docs
        .map((d) => ({ id: d.id, ...(d.data() as Omit<VolunteerNotification, 'id'>) }))
        .filter((n) => !n.read);
      list.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      onData(list);
    },
    (error) => {
      console.warn('Volunteer notifications snapshot error:', error);
    }
  );
}

export async function addVolunteerNotification(
  reservationId: string,
  reservationCode: string,
  type: 'date_change' | 'note_added' | 'cancelled' | 'new_order',
  message: string
): Promise<void> {
  const ref = doc(collection(db, COLLECTION_NAME));
  const newNotif: VolunteerNotification = {
    id: ref.id,
    createdAt: new Date().toISOString(),
    reservationId,
    reservationCode,
    type,
    title: `Reservation ${reservationCode}`,
    message,
    read: false
  };
  await setDoc(ref, newNotif);
}

export async function dismissVolunteerNotification(id: string): Promise<void> {
  const ref = doc(db, COLLECTION_NAME, id);
  await updateDoc(ref, { read: true });
}
